// Complex cards keep their existing markup. Keyboard activation dispatches the
// same click as a pointer; nested native controls retain their own activation.
const handlers = new WeakMap();
export default {
  bind(element) {
    element.classList.add('keyboard-action');
    const handler = event => {
      if (event.target !== element || event.isComposing || event.altKey || event.ctrlKey || event.metaKey) return;
      if (element.disabled || element.getAttribute('aria-disabled') === 'true') return;
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        if (!event.repeat) element.click();
      } else if (element.getAttribute('role') === 'radio' && ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        const group = element.closest('[role="radiogroup"]');
        if (!group) return;
        const radios = Array.from(group.querySelectorAll('[role="radio"]')).filter(node => node.getAttribute('aria-disabled') !== 'true');
        const index = radios.indexOf(element);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? radios.length - 1
          : (index + (['ArrowRight', 'ArrowDown'].includes(event.key) ? 1 : -1) + radios.length) % radios.length;
        event.preventDefault();
        if (radios[next]) { radios[next].click(); radios[next].focus(); }
      }
    };
    handlers.set(element, handler);
    element.addEventListener('keydown', handler);
  },
  unbind(element) {
    element.removeEventListener('keydown', handlers.get(element));
    handlers.delete(element);
  },
};
